module.exports = __webpack_public_path__ + "static/media/lake.d4e28ef1.jpg";